import React from 'react';
import { Link } from 'react-router-dom';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import VerticalBookCard from 'rebook/apps/books/components/VerticalBookCard';

import styles from './style.scss';


const SimilarBookList = ({ bookList, book, isAudioBook }) => {
  const bookText = isAudioBook ? 'Аудиокниги' : 'Книги';
  /*
   * Пока рекомендатор не научится отдавать
   * похожие аудиокниги, не показываем
   * этот блок
   */
  if (isAudioBook) {
    return null;
  }
  const bookCardList = bookList.map((item) => (
    <VerticalBookCard
      key={item.id}
      book={item} />
  ));
  return (
    <div className="billetContainerNoOverflow ">
      <div className={styles.similarBooksTitle}>
        <div className="title-2">
          <h2>
            {`${bookText}, похожие на `}
            <span className={styles.titleBookName}>«{book.name}»</span>
          </h2>
        </div>
        <Link to={{
          pathname: `${book.absolute_url}similar/`,
          state: { bookList, book },
        }}>
          <span className="link">Все</span>
        </Link>
      </div>
      <p className={styles.subTitle}>По жанру, теме или стилю автора</p>
      <div className={styles.ContentCarousel}>
        <ContentCarousel>
          {bookCardList}
        </ContentCarousel>
      </div>
    </div>
  );
};

export default SimilarBookList;
